import axios from 'frontend/_config/axios'
import setupRouter from 'frontend/_setup/setupRouter/setupRouter'
import { ResourceService } from 'frontend/common/services/resource-service'
import { SimpleSelectService } from 'frontend/common/services/simple-select-service'

export class MapZonesService extends ResourceService {
  eventSlug: string
  selectService: SimpleSelectService
  constructor({
    eventSlug = setupRouter.currentRoute?.value?.params?.eventSlug,
    baseUrl = `/events/${eventSlug}/map_zones`,
    blocker = null,
    fetchError = 'Failed to fetch map zone.',
    saveError = 'Failed to save map zone.',
    apiProvider = axios,
    selectService = new SimpleSelectService(baseUrl, {
      apiProvider,
      blocker,
      blockerKey: 'map zones',
    }),
  } = {}) {
    super({
      apiProvider,
      baseUrl,
      blocker,
      fetchError,
      saveError,
    })
    this.selectService = selectService
    this.eventSlug = eventSlug
  }
}
